<template>
  <v-dialog
    v-model="dialogAddPermissao"
    @click:outside="$emit('update:dialogAddPermissao', false)"
    @keydown.esc="$emit('update:dialogAddPermissao', false)"
    max-width="1210px"
  >
    <v-card>
      <v-card-title class="accent text-h5 font-weight-bold">
        <v-icon color="primary" left>mdi-account-group</v-icon>
        Adicionar Permissão
        <v-spacer></v-spacer>

        <v-icon
          color="black"
          @click="$emit('update:dialogAddPermissao', false)"
        >
          mdi-close
        </v-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="px-6 py-8">
        <v-form v-model="valid" ref="form">
          <v-row>
            <v-col cols="12" md="4">
              <v-card
                outlined
                height="40px"
                class="d-flex justify-space-between align-center"
              >
                <v-card-text class="text-body-1 py-0">
                  {{ `Status: ${permissao.status ? "Ativo" : "Inativo"}` }}
                </v-card-text>
                <v-switch
                  class="ma-0"
                  hide-details
                  :color="permissao.status ? 'secondary' : 'success'"
                  v-model="permissao.status"
                ></v-switch>
              </v-card>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                v-model.lazy="permissao.componente"
                label="componente"
                :rules="[rules.required]"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                :items="permissoes"
                clearable
                label="Permissão Pai"
                dense
                editable
                hide-details
                item-text="descricao"
                item-value="id"
                v-model="permissao.permissao_id"
                outlined
                return-object
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="8">
              <v-text-field
                v-model="permissao.descricao"
                label="descrição"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="permissao.descricao_detalhe"
                label="descrição detalhada"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>

            <v-row class="px-3 mt-1" align-content="stretch">
              <v-col>
                <v-card height="100%" outlined>
                  <v-subheader> ACESSOS </v-subheader>
                  <v-divider light class="mt-n2"></v-divider>
                  <v-card-text>
                    <v-checkbox
                      v-model="bitWise.menu"
                      class="mt-0"
                      :false-value="0"
                      :true-value="128"
                      label="Menu"
                      hide-details
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card height="100%" outlined>
                  <v-subheader> CRUD </v-subheader>
                  <v-divider light class="mt-n2"></v-divider>
                  <v-card-text>
                    <v-checkbox
                      v-model="bitWise.visualizar"
                      class="mt-0"
                      :false-value="0"
                      :true-value="1"
                      label="Visualizar"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="bitWise.adicionar"
                      class="mt-0"
                      :false-value="0"
                      :true-value="2"
                      label="Adicionar"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="bitWise.editar"
                      class="mt-0"
                      :false-value="0"
                      :true-value="4"
                      label="Editar"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="bitWise.deletar"
                      class="mt-0"
                      :false-value="0"
                      :true-value="8"
                      label="Deletar"
                      hide-details
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card height="100%" outlined>
                  <v-subheader> IMPRESSÃO </v-subheader>
                  <v-divider light class="mt-n2"></v-divider>
                  <v-card-text>
                    <v-checkbox
                      v-model="bitWise.imprimir"
                      class="mt-0"
                      :false-value="0"
                      :true-value="16"
                      label="Imprimir"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="bitWise.exportar"
                      class="mt-0"
                      :false-value="0"
                      :true-value="32"
                      label="Exportar"
                      hide-details
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card height="100%" outlined>
                  <v-subheader> CUSTOMIZADO </v-subheader>
                  <v-divider light class="mt-n2"></v-divider>
                  <v-card-text>
                    <v-checkbox
                      v-model="bitWise.limitar"
                      class="mt-0"
                      :false-value="0"
                      :true-value="64"
                      label="limitar"
                      hide-details
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click.prevent="novaPermissao"
          class="white--text"
          color="secondary"
          :disabled="!valid"
        >
          Adicionar
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getPermissoes, postPermissao } from "@/api/admin/permissoes.js";
// import { mapGetters } from "vuex";

export default {
  name: "NovaPermissao",

  props: {
    dialogAddPermissao: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    permissao: {
      status: true,
    },
    bitWise: {
      visualizar: 0,
      adicionar: 0,
      editar: 0,
      deletar: 0,
      imprimir: 0,
      exportar: 0,
      limitar: 0,
      menu: 0,
    },
    permissoes: [],
    show: false,
    valid: false,
    loading: true,
    rules: {
      required: (value) => !!value || "Obrigatorio.",
      min: (v) => v.length >= 3 || "Minimo 4 caracteres",
    },
  }),

  computed: {},

  methods: {
    backHistory() {
      this.$router.go(-1);
    },

    resetForm() {
      this.$refs.form.reset();
    },

    fetchPermissoes(filtro) {
      return getPermissoes(filtro ? filtro : "")
        .then((response) => {
          response.forEach((resp) => {
            this.permissoes.push(resp);
            resp.children.forEach((child) => {
              this.permissoes.push(child);
            });
          });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    novaPermissao() {
      this.permissao.bits =
        this.bitWise.visualizar +
        this.bitWise.adicionar +
        this.bitWise.editar +
        this.bitWise.deletar +
        this.bitWise.imprimir +
        this.bitWise.exportar +
        this.bitWise.limitar +
        this.bitWise.menu;

      postPermissao(this.permissao)
        .then((response) => {
          if (response.status === 201) {
            this.$toast.success("Criado com sucesso!");
            this.resetForm();
            this.permissao.status = true;
            this.fetchPermissoes();
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            if (error.response.data.descricao) {
              this.$toast.error(error.response.data.descricao[0]);
            }
            if (error.response.data.status) {
              this.$toast.error(error.response.data.status[0]);
            }
          } else {
            this.$toast.error(error);
          }
        });
    },
  },

  mounted() {
    this.fetchPermissoes();
  },
};
</script>

<style scoped lang="scss"></style>
